var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gate"},[(_vm.face === 'gadgets')?_c('h3',[_vm._v(_vm._s(_vm.$t('layout.gadgetsgate')))]):(_vm.face === 'chrome')?_c('h3',[_vm._v(_vm._s(_vm.$t('layout.chromegate')))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }